'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GoRocket = function GoRocket(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm28 4.8c-2.8 1.7-5.8 3.8-8.5 6.6-1.8 1.7-3.2 3.4-4.3 5l-7 1.3-8.2 8.2 7.3 0.2 5.1-5.1c-1.8 3.7-1.9 6.2-1.9 6.2l2.3 2.3s2.5-0.2 6.3-2l-5.2 5.2 0.2 7.3 8.2-8.2 1.3-7c1.6-1.1 3.3-2.5 5-4.3 2.8-2.7 4.9-5.7 6.6-8.5-1.8-0.4-3.5-1.1-4.8-2.4-1.3-1.3-2-3-2.4-4.8z m2.7-1.4c0.2 1.8 0.8 3.2 1.8 4.1 0.9 1 2.3 1.6 4.1 1.8 2.6-5.2 3.4-9.3 3.4-9.3s-4.1 0.8-9.3 3.4z' })
        )
    );
};

exports.default = GoRocket;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/go/rocket.js
// module id = 1768
// module chunks = 0